<div class="p-pb-4">
    <p-card>
        <ng-template pTemplate="header">
            <div class="p-card-title">
                Datos generales
            </div>
        </ng-template>
        <ng-template pTemplate="content">
            <div class="p-grid">
                <div class="p-col-3 p-field">
                    <label for="fechaFactura">{{'sales.factura.fecha' | translate}}</label>
                    <input id="fechaFactura" type="text" pInputText [value]="sale?.FechaFactura | date:'shortDate'"
                        readonly />
                </div>
                <div class="p-col-3 p-field">
                    <label for="serieFactura">{{'sales.factura.serie' | translate}}</label>
                    <input id="serieFactura" type="text" pInputText [value]="sale?.SerieFactura" readonly />
                </div>
                <div class="p-col-3 p-field">
                    <label for="numeroFactura">{{'sales.factura.numero' | translate}}</label>
                    <input id="numeroFactura" type="text" pInputText [value]="sale?.NumeroFactura" readonly />
                </div>
                <div class="p-col-3 p-field">
                    <label for="razonSocial">{{'sales.factura.razon_social' | translate}}</label>
                    <input id="razonSocial" type="text" pInputText [value]="sale?.RazonSocial" readonly />
                </div>
            </div>
        </ng-template>
    </p-card>
</div>
<div class="p-pb-4">
    <p-card>
        <ng-template pTemplate="header">
            <div class="p-card-title">
                Líneas
            </div>
        </ng-template>
        <ng-template pTemplate="content">
            <div class="sales-lines-table">
                <p-table [value]="salesLines" [responsive]="true" responsiveLayout="scroll" [paginator]="true" [rows]="10" [loading]="loadingLines"
                    [emptyMessage]="'general.no_results' | translate">
                    <ng-template pTemplate="header">
                        <tr>
                            <th>Código de artículo</th>
                            <th>Código Empresa</th>
                            <th>Descripción Artículo</th>
                            <th>Base IVA</th>
                            <th>Importe Líquido</th>
                            <th>Precio</th>
                            <th>Total IVA</th>
                            <th>Unidades</th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-line>
                        <tr>
                            <td>{{ line.CodigoArticulo }}</td>
                            <td>{{ line.CodigoEmpresa }}</td>
                            <td>{{ line.DescripcionArticulo }}</td>
                            <td>{{ line.BaseIva }}</td>
                            <td>{{ line.ImporteLiquido }}</td>
                            <td>{{ line.Precio }}</td>
                            <td>{{ line.TotalIva }}</td>
                            <td>{{ line.Unidades }}</td>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="emptymessage">
                        <tr>
                            <td colspan="8">{{'general.not_data' | translate }}</td>
                        </tr>
                    </ng-template>
                </p-table>

            </div>
        </ng-template>
    </p-card>
</div>

<div style="display: flex; flex-direction: column; font-weight: bold;">
    <div style="display: flex; justify-content: right; gap: 1rem;">
        <label>{{'sales.factura.base_imponible' | translate}}</label>
        <label style="width: 100px; text-align: right;">{{sale?.BaseImponible | number:'0.00'}}&euro;</label>
    </div>
    <div style="display: flex; justify-content: right; gap:  1rem;">
        <label>{{'sales.factura.total_iva' | translate}}</label>
        <label style="width: 100px; text-align: right;">{{sale?.TotalIva | number:'0.00'}}&euro;</label>
    </div>
    <div style="display: flex; justify-content: right; gap:  1rem;">
        <label>{{'sales.factura.importe' | translate}}</label>
        <label style="width: 100px; text-align: right;">{{sale?.ImporteFactura | number:'0.00'}}&euro;</label>
    </div>
</div>